import { Box, Input, Typography } from "@bca/ui-library";
import React from "react";

interface VrmSearchInputProps {
  vrmQuery: string;
  warning: boolean;
  isMobile?: boolean;
  onChange: (vrmQuery: string) => void;
  onEnter?: () => void;
}

const VrmSearchInput: React.FunctionComponent<VrmSearchInputProps> = ({
  vrmQuery,
  warning,
  isMobile = false,
  onChange,
  onEnter = () => {},
}) => {
  const onVrmQueryChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.value);

  const onVrmInputKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onEnter();
    }
  };

  return (
    <Box
      mt={isMobile ? 6 : 0}
      mb={isMobile ? "20px" : "44px"}
      px={0}
      width="100%"
    >
      <Input
        width="100%"
        placeholder="Search by Registration"
        onChange={onVrmQueryChange}
        value={vrmQuery}
        error={false}
        warning={warning}
        onKeyDownCapture={onVrmInputKeyPress}
        css="box-shadow: none;"
      />
      {warning && (
        <Typography color="secondary-orange" marginBottom={0} marginTop={2}>
          Please enter 3 characters
        </Typography>
      )}
    </Box>
  );
};

export default VrmSearchInput;
